<template>
    <drawer title="Create a new Media folder" class="flex-create-media-folder" @hidden="onClose">
        <div class="page-data__container">
            <div v-show="isSaving">
                <loading-component />
            </div>

            <template v-show="!isSaving">
                <section>
                    <h2 class="flex-form__section-title">
                        Media Folder Name
                    </h2>

                    <label class="flex-form__field">
                        <div class="flex-form__label">
                            Folder Name
                        </div>

                        <input
                            v-model="name"
                            class="flex-form__input"
                            type="text"
                        >
                    </label>

                    <button
                        class="flex-page-data__button flex-page-data__button--continue"
                        @click="createMediaFolder"
                    >
                        CREATE
                    </button>

                    <button
                        class="flex-page-data__button flex-page-data__button--cancel"
                        @click="onClose"
                    >
                        CANCEL
                    </button>
                </section>
            </template>
        </div>
    </drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import LoadingComponent from '@/components/shared/loading/loading-component';
import Drawer from '@/components/shared/drawer/drawer';
import * as service from '@/sitecore/sitecore-data-service';
import { SHOW_ALERT, HIDE_DRAWER, SHOW_DRAWER } from '@/store/types/mutation-types';
import { drawerHelperMixin } from '@/mixins/drawer-helper';

export default {
    components: {
        Drawer,
        LoadingComponent,
    },

    mixins: [drawerHelperMixin],

    data() {
        return {
            isSaving: false,
            showNav: true,
            name: '',
        };
    },

    computed: {
        ...mapState({
            newPagePath: ({ page }) => page.newPagePath,
        }),
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
            showAlert: SHOW_ALERT,
            showDrawer: SHOW_DRAWER,
        }),

        async createMediaFolder() {
            if (!this.validInput()) {
                return;
            }

            this.isSaving = true;

            const itemData = { path: this.newPagePath, name: this.name };
            const response = await service.createMediaFolder(itemData);

            if (response.status === 'error') {
                this.showAlert({
                    title: 'Folder Creation Failed',
                    description: 'Either the server is down, or the folder name you are entering already exists.',
                });

                this.isSaving = false;
                return;
            }

            this.name = '';
            this.isSaving = false;
            this.hideDrawer();
            await this.$nextTick();

            this.showDrawer({
                componentTag: 'navigation-tree-media',
                data: {
                    id: response.data,
                },
            });
        },

        async onClose() {
            this.hideDrawer();
            await this.$nextTick();
            this.showDrawer('navigation-tree-media');
        },

        validInput() {
            if (!this.name) {
                this.showAlert({ description: 'Name value is required' });
                return false;
            }

            return true;
        },
    },
};
</script>

<style lang="scss">
.flex-create-media-folder {
    overflow-y: auto;

    .page-data {
        &__container {
            min-width: 100%;
            height: calc(100vh - #{ $drawer-header-height } - 50px); // 50px = height of buttons on bottom
            overflow-y: auto;
            padding: 15px;
        }
    }

    .flex-page-data__button {
        margin-right: 15px;
    }
}
</style>
